module.exports = __webpack_public_path__ + "img/PSS-logo2.0f6e48af.png";